import React, { useContext, useEffect, useState } from 'react'
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import { Default_Page_Limit, Default_Page_Number } from '../../../../constants/defaultValues';
import { HeaderHeading } from '../../../../Context';
import constant from '../../../../constants/constant';
import service from '../../../../api/services';
import { getParams } from '../../../../constants/utils';
import { useSearchParams } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';

const { ApproveBarcode } = organisms
const Index = () => {
    const { addToast } = useToasts();
    const [searchParams] = useSearchParams();
    const [typeValue, setTypeValue] = useState<any>(getParams('approve-barcode-type') == constant.BRAND_CATEGORY[0].value)
    const [barcodeStatusList, setBarcodeStatus] = useState<string>()
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);
    const [allBarcode, setAllBarcode] = useState<any>([]);
    const [isContactLensProduct, setIsContactLensProduct] = useState<boolean>(false)
    const [barcodeFormat, setBarcodeFormat] = useState<string>(constant.BARCODE_FORMAT.STANDARD);
    const [initialized, setInitialized] = useState<boolean>(false);
    const [params, setParams] = useState({
        limit: Default_Page_Limit,
        page: Default_Page_Number,
        search: ''
    })




    const getBarcodeStatus = async () => {
        const data = {
            search: params?.search,
            page: params?.page,
            limit: params?.limit,
            barcode_status: constant?.BARCODE_STATUS?.APPROVED,
            is_recognised: typeValue,
            is_contact_lens: isContactLensProduct
        }
        try {
            const response: any = await service.barcode.view(data);
            setBarcodeStatus(response.data)
            const combinedArray = [...allBarcode, ...response.data.data];
            const uniqueIds = new Set<number>();

            // Filter the combined array to include only unique entries based on ID
            const uniqueArray = combinedArray.filter((item) => {
                if (!uniqueIds.has(item.id)) {
                    uniqueIds.add(item.id);
                    return true;
                }
                return false;
            });
            // Update the state with the unique array
            setAllBarcode(uniqueArray);
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    //to set the params
    const handleParams = (value: string | number, name: string) => {
        setParams((prevState) => ({
            ...prevState,
            page: name === 'page' ? value as number : Default_Page_Number,
            ...(name !== 'page' && { [name]: value }),
        }));
    };
    //end

    // to handle the unrecognized and recognize section
    useEffect(() => {
        setTypeValue(getParams('approve-barcode-type') == constant.BRAND_CATEGORY[0].value)
        setAllBarcode([])
        setParams({
            limit: Default_Page_Limit,
            page: Default_Page_Number,
            search: ''
        })
        setInitialized(true)
    }, [searchParams,isContactLensProduct])
    // end

    useEffect(() => {
        setHeader("Inventory - Approve Barcode");
        initialized && getBarcodeStatus();
    }, [params])

    return (
        <Wrapper>
            <ApproveBarcode
                barcodeStatusList={barcodeStatusList}
                setSearch={(value:string)=> handleParams(value,'search')}
                setLimitPerPage={(value:number)=> handleParams(value,'limit')}
                setCurrentPage={(value:number)=> handleParams(value,'page')}
                getBarcodeStatus={getBarcodeStatus}
                currentPage={params?.page}
                limit={params?.limit}
                allBarcode={allBarcode}
                isRecognized={typeValue == constant.BRAND_CATEGORY[0]?.value}
                isContactLensProduct={isContactLensProduct}
                setIsContactLensProduct={setIsContactLensProduct}
                barcodeFormat={barcodeFormat}
                setBarcodeFormat={setBarcodeFormat}
            />
        </Wrapper>
    )
}

export default Index